// see https://plonerestapi.readthedocs.io/en/latest/endpoints/users.html?highlight=reset#reset-user-password
// react core
import React from 'react';
import { useState } from 'react';
import { Link } from "react-router-dom";

// libs
import { route_to_full_url } from 'utils/helpers';

// components
import UserLogged from 'components/commons/user_logged';
import IsEmailValidator from 'components/commons/is_email_validator';
import IsCommunityCodeValidator from 'components/commons/is_community_code_validator';
import ErrorMessage from 'components/commons/error_msg';
import AjaxSpinner from 'components/commons/ajax_spinner';

// libs
import { AUTH } from 'api/account';
import { check_if_email } from 'utils/helpers';
import usePageTitle from 'utils/page_title';

function ButtonSender({ username, id_code, on_click })
{
    if (username.length > 6 && check_if_email(username) && id_code !== '')
    {
        return (
            <button onClick={on_click} className="button button-primary">Register</button>
        )
    }
    else
    {
        return (
            <button disabled className="button button-primary">Register</button>
        )
    }
}

export default function RegisterPage({ user })
{
    usePageTitle('Register');
    // default data
    const [email, set_email] = useState('');
    const [id_code, set_id_code] = useState('');
    const [is_submitted, set_is_submitted] = useState(false);
    const [errors, set_errors] = useState(false);
    const [error_msg, set_error_msg] = useState('');
    const [is_await, set_is_await] = useState(false);
    // send credentials
    const handle_submit = (evt) =>
    {
        evt.stopPropagation();
        evt.preventDefault();
        const send_data = async () =>
        {
            const response = await AUTH.register_user(email, id_code);
            if (response.ok) // 200 response check status
            {
                // set_email('');
                // set_id_code('');
                set_is_await(false);
                const data = await response.json();
                if (data.status === 'ok')
                {
                    set_errors(false);
                    set_is_submitted(true);
                }
                else if (data.status === 'error')
                {
                    set_errors(true);
                    set_error_msg(data.message);
                }
                else
                {
                    set_errors(true);
                    set_error_msg('Server error');
                }
            }
            else
            {
                set_is_await(false);
                set_errors(true);
                set_error_msg('Server error');
            }
        }
        // call the function
        set_is_await(true);
        send_data().catch(console.error);
    };
    if (user.ok === true && user.username !== '')
    {
        return (
            <UserLogged />
        )
    }
    else
    {
        if(is_submitted) return (
            <>
            <h2>
            Register to the CCH<sup>&reg;</sup> Tagetik Community!
            </h2>
            <div className='confirm-message'>
                <div>
                    <strong>Almost there!</strong>
                    <span>Check your email box and follow the link to complete your registration process.</span>
                </div>
            </div>
            </>
        );
        else
        {
            let classess = (errors) ? 'auth-form error' : 'auth-form';
            classess += is_await ? ' loading' : '';
            return (
                <>
                    <h2>
                        Register to the CCH<sup>&reg;</sup> Tagetik Community!
                    </h2>
                    <p>
                        The CCH® Tagetik Community is the central website reserved to our employees, partners and
                        clients.
                    </p>
                    <p>
                        To join the CCH® Tagetik Community please enter the Community ID Code you should have received
                        by email. <br />
                        If you don't have your Community ID Code, please send an email to{" "}
                        <a href="mailto:tgk-dl-community@wolterskluwer.com">tgk-dl-community@wolterskluwer.com</a>
                    </p>
                    <AjaxSpinner show={is_await} />
                    <form action="#" id="login-form" className={classess}>
                        <div className="auth-form-errors">
                            <i className="fa-solid fa-circle-exclamation"></i>
                            <ErrorMessage display={errors} msg={error_msg} />
                        </div>
                        <fieldset>
                            <div className="auth-form-field">
                                <input
                                    name="username"
                                    id="register-form-username"
                                    type="text"
                                    required
                                    value={email}
                                    autoComplete="username"
                                    placeholder="Your business email address"
                                    onChange={(e) => {set_email(e.target.value); set_errors(false)}}
                                />
                                <label htmlFor="register-form-username">
                                    Your business email address <IsEmailValidator username={email} />
                                </label>
                            </div>
                            <div className="auth-form-field">
                                <input
                                    name="code"
                                    id="register-form-code"
                                    type="text"
                                    required
                                    value={id_code}
                                    autoComplete="off"
                                    placeholder="Community ID Code"
                                    onChange={(e) => {set_id_code(e.target.value); set_errors(false)}}
                                />
                                <label htmlFor="register-form-code">
                                    Community ID Code <IsCommunityCodeValidator code={id_code} />
                                </label>
                            </div>
                        </fieldset>
                        <div className='auth-form-buttons'>
                            <ButtonSender username={email} code={id_code} on_click={handle_submit} />
                        </div>

                    </form>

                    <p>Already have an account? <Link className='primary' to={route_to_full_url("login")}>Log in here</Link></p>
                </>
            );
        }
    }
};
